export default __webpack_public_path__ + "static/atoms_title-10a64600a51f2d73343dc5f0b2d540da.svg";